<template>
    <footer class="foot-bg" :class="$route.name=='Home'?'foot-bgw':''">
        <div class="main-container">
            <!--<h4><img src=""/>采购投诉反馈</h4>-->
            <el-row class="foot-title">
                <el-col>
                   <span class="boldLine"></span>反舞弊举报受理
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <p >廉洁举报电话：86-10-8440 8717</p>
                    <p >廉洁举报邮箱：sunnymoma@modernland.hk</p>
                    <p >廉洁举报手机号：18811151021</p>
                </el-col>
                <el-col :span="8">
                    <p >廉洁举报信件邮寄地址：北京香河园路1号万国城 10号楼4层</p>
                    <p >邮编：100028</p>
                </el-col>
                <el-col :span="8" class="pic_right">
                    <img src="../../assets/images/index/fpptLogo.png"/>
                </el-col>
            </el-row>
        </div>
        <div class="text-center copy">版权所有Copyright©2018 ΜΟΜΛ当代节能置业招采平台</div>
    </footer>
</template>
<script>
    export default {
        name: 'my-footer',
        data() {
            return{

            }
        }
    }
</script>
<style>
    .foot-bg {
        background: #141827;
    }
    .foot-bgw {
        background: #fff;
    }
    .foot-bg .main-container {
        /*margin-bottom: 84px;*/
        margin: 30px auto;
        position: relative;
    }
    .foot-bg .el-col {
        font-size: 14px;
        color: #fff;
        text-align: left;
        line-height: 28px;
    }
    .foot-title .el-col {
        font-size: 16px;
        font-weight: 700;
        margin-top: 24px;
        margin-bottom: 30px;
    }
    .boldLine {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #fff;
        vertical-align: middle;
        margin-right: 8px;
    }
    .foot-bg .el-col p {margin: 0;padding: 0;}
    .foot-bg .copy {
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        /*color: #C4CACD;*/
        color: #fff;
        background: #2D3336;
    }
    .foot-bg .pic_right {
        text-align: right;
    }
    .pic_right img {
        width: 80px;
        height: 106.9px;
        position: absolute;
        right: 10px;
        top: -50px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Footer.vue